/*
  Action Types
 */

export const SAMPLE_REQUEST = 'SAMPLE_REQUEST';
export const GET_JOBS_SUCCESS = 'GET_JOBS_SUCCESS';
export const SAMPLE_FAILURE = 'SAMPLE_FAILURE';



// WEBPACK FOOTER //
// ./app/jobs/constants/jobsConstants.js